import { Controller } from "@hotwired/stimulus"
import { changerIcone } from "../lib/icones"

// Drives the pre-live and waiting live_event pages:
//   1. Renders days/hours/minutes/seconds countdown (or the legacy single
//      `display` target — both are kept compatible).
//   2. Polls the status endpoint and redirects to /join when the host
//      starts the live.
//   3. Enables the "Rejoindre" button at openAt (default scheduledAt - 15min).
export default class extends Controller {
  static targets = ["display", "status", "days", "hours", "minutes", "seconds", "joinBtn"]
  static values  = {
    scheduledAt: String,
    statusUrl:   String,
    joinUrl:     String,
    openAt:      String
  }

  connect() {
    this.tick()
    this.interval = setInterval(() => this.tick(), 1000)
    this.poll()
    this.pollInterval = setInterval(() => this.poll(), 10000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
    if (this.pollInterval) clearInterval(this.pollInterval)
  }

  tick() {
    const target = new Date(this.scheduledAtValue).getTime()
    const diffMs = target - Date.now()
    const total  = Math.max(0, Math.floor(diffMs / 1000))

    const d = Math.floor(total / 86400)
    const h = Math.floor((total % 86400) / 3600)
    const m = Math.floor((total % 3600) / 60)
    const s = total % 60

    if (this.hasDaysTarget)    this.daysTarget.textContent    = String(d).padStart(2, "0")
    if (this.hasHoursTarget)   this.hoursTarget.textContent   = String(h).padStart(2, "0")
    if (this.hasMinutesTarget) this.minutesTarget.textContent = String(m).padStart(2, "0")
    if (this.hasSecondsTarget) this.secondsTarget.textContent = String(s).padStart(2, "0")

    if (this.hasDisplayTarget) {
      const hh = String(Math.floor(total / 3600)).padStart(2, "0")
      this.displayTarget.textContent = `${hh}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`
    }

    this.refreshJoinButton(diffMs)
  }

  refreshJoinButton(diffMs) {
    if (!this.hasJoinBtnTarget) return
    const open = this.openAtValue
      ? Date.now() >= new Date(this.openAtValue).getTime()
      : diffMs <= 15 * 60 * 1000

    const btn = this.joinBtnTarget
    if (open && btn.classList.contains("is-disabled")) {
      btn.classList.remove("is-disabled")
      btn.removeAttribute("aria-disabled")
      changerIcone(btn.querySelector(".lucide"), "circle-play")
      const last = btn.lastChild
      if (last && last.nodeType === Node.TEXT_NODE) {
        last.textContent = " Rejoindre la salle"
      }
      if (this.hasStatusTarget) this.statusTarget.textContent = "La salle est ouverte"
    }
  }

  async poll() {
    if (!this.statusUrlValue) return
    try {
      const res = await fetch(this.statusUrlValue, { headers: { Accept: "application/json" } })
      if (!res.ok) return
      const data = await res.json()
      if (data.status === "live") {
        if (this.hasStatusTarget) this.statusTarget.textContent = "Le live démarre — redirection…"
        if (this.joinUrlValue) window.location.href = this.joinUrlValue
      } else if (data.status === "ended") {
        if (this.hasStatusTarget) this.statusTarget.textContent = "Le webinaire est terminé."
        if (this.pollInterval)    clearInterval(this.pollInterval)
      }
    } catch (_e) {
      // silent
    }
  }
}
